import React from 'react';
import './index.scss';
import { getTeamLogo } from './getTeamLogo';
import { Participant } from '@draftkings/sportsbook-common-contracts';

interface TeamLogoProps {
    logoUrl: string | undefined;
    teamName: string;
    staticS3Host: string;
    onLoad: () => void;
    onError: () => void;
    loaded: boolean;
    participant?: Participant;
    isSwooshTeamLogosEnabledForEventPage?: boolean;
    swooshBaseUrl: string;
}

export const TeamLogo = React.forwardRef(function TeamLogoComponent(
    {
        logoUrl,
        teamName,
        staticS3Host,
        onLoad,
        onError,
        loaded,
        participant,
        isSwooshTeamLogosEnabledForEventPage,
        swooshBaseUrl
    }: TeamLogoProps,
    ref: React.ForwardedRef<HTMLImageElement>
) {
    if (!isSwooshTeamLogosEnabledForEventPage && !logoUrl) {
        return null;
    }

    const imageAlt = `${teamName}-logo`;
    const imageSrc = getTeamLogo(
        staticS3Host,
        logoUrl,
        swooshBaseUrl,
        participant,
        isSwooshTeamLogosEnabledForEventPage
    );

    return (
        <div className={loaded ? '' : 'ep-event-name__team-logo-skeleton'}>
            <img
                className="ep-event-name__team-logo"
                data-testid="ep-event-team-logo"
                ref={ref}
                alt={imageAlt}
                src={imageSrc}
                onLoad={onLoad}
                onError={onError}
                style={{ visibility: loaded ? 'visible' : 'hidden' }}
            />
        </div>
    );
});
